import { useTranslation } from '../i18n/LanguageContext.jsx';
import './LanguageSwitcher.css';

// Hungarian flag SVG (red, white, green horizontal stripes)
const HungarianFlag = () => (
  <svg
    viewBox="0 0 24 16"
    xmlns="http://www.w3.org/2000/svg"
    className="flag-icon"
    role="img"
    aria-hidden="true"
  >
    <rect width="24" height="5.33" y="0" fill="#CD2A3E" />
    <rect width="24" height="5.33" y="5.33" fill="#FFFFFF" />
    <rect width="24" height="5.33" y="10.67" fill="#436F4D" />
  </svg>
);

// UK flag SVG (Union Jack)
const UKFlag = () => (
  <svg
    viewBox="0 0 24 16"
    xmlns="http://www.w3.org/2000/svg"
    className="flag-icon"
    role="img"
    aria-hidden="true"
  >
    {/* Blue background */}
    <rect width="24" height="16" fill="#012169" />
    {/* White diagonals */}
    <path d="M0,0 L24,16 M24,0 L0,16" stroke="#FFFFFF" strokeWidth="3" />
    {/* Red diagonals */}
    <path d="M0,0 L24,16 M24,0 L0,16" stroke="#C8102E" strokeWidth="1.5" />
    {/* White cross */}
    <path d="M12,0 V16 M0,8 H24" stroke="#FFFFFF" strokeWidth="5" />
    {/* Red cross */}
    <path d="M12,0 V16 M0,8 H24" stroke="#C8102E" strokeWidth="3" />
  </svg>
);

/**
 * LanguageSwitcher component.
 *
 * @param {Object} props
 * @param {'fixed'|'inline'} [props.variant='fixed'] - Positioning mode.
 *   'fixed' renders as a fixed-position overlay (default, for standalone use).
 *   'inline' renders in normal document flow (for embedding inside other components).
 */
function LanguageSwitcher({ variant = 'fixed' }) {
  const { language, setLanguage } = useTranslation();

  return (
    <div className={`language-switcher${variant === 'inline' ? ' language-switcher--inline' : ''}`}>
      <button
        className={`lang-btn ${language === 'hu' ? 'active' : ''}`}
        onClick={() => setLanguage('hu')}
        aria-label="Magyar nyelv"
        title="Magyar"
      >
        <HungarianFlag />
      </button>
      <button
        className={`lang-btn ${language === 'en' ? 'active' : ''}`}
        onClick={() => setLanguage('en')}
        aria-label="English language"
        title="English"
      >
        <UKFlag />
      </button>
    </div>
  );
}

export default LanguageSwitcher;
